module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAb0lEQVR42u3aMQHAQAzEsOOPrZz8Q2FEgwlo9qpdbgAAAAAAAAAAAAAAHAfY1qUAAAAAAAAAAAAAAAAA4G/rVAAAAAAAAAAAAAAAAABQrW+dCgAAAAAAAAAAAAAAAAAAGCUBAAAAAAAAAAAAALjWA6kBEAfC9SDsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Germany.png
// module id = mNd9
// module chunks = 0 62 63